import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
    {
        q: "How do I get started with therapy?",
        a: "The easiest first step is scheduling a free consultation. It is a short, warm, pressure-free conversation where you can ask any questions you have — about EMDR, about the process, about whether we might be a good fit. There is no obligation to commit. We simply talk and see how it feels.",
    },
    {
        q: "Who is therapy at Alchemy Practice for?",
        a: "This work is designed for discerning, driven adults who feel capable of more — but notice fear, hesitation, or self-doubt quietly shaping their decisions. People who look composed on the outside, and are tired of carrying what no one else can see.",
    },
    {
        q: "What approaches do you use in therapy?",
        a: "I use evidence-based approaches including EMDR, Brainspotting, ACT, and DBT-informed work — to help clients process earlier experiences, develop emotional flexibility, and build a quieter, more grounded confidence.",
    },
    {
        q: "What happens in the first session?",
        a: "The first session is a chance to talk about what has been bringing you to therapy and to explore whether working together feels like a good fit. There is nothing you need to prepare. We start where you are.",
    },
    {
        q: "How do EMDR, ACT, and DBT actually help with confidence?",
        a: "Each approach contributes something different. EMDR processes the earlier experiences that may still influence what you believe about yourself. ACT clarifies values so fear stops choosing for you. DBT offers practical, in-the-moment skills for navigating intense emotion. Together, they create durable, integrated change.",
    },
    {
        q: "How long does therapy take?",
        a: "It varies. Some clients notice meaningful shifts within a few months. Others prefer longer-term work to fully integrate what they are uncovering. We talk openly about pace, and we revisit it as we go.",
    },
];

function Item({ q, a, idx }) {
    const [open, setOpen] = useState(idx === 0);
    return (
        <div className="border-b" style={{ borderColor: "#E2DDD8" }} data-testid={`faq-item-${idx}`}>
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-start justify-between gap-6 py-8 text-left group"
                data-testid={`faq-trigger-${idx}`}
            >
                <span className="font-serif text-2xl sm:text-3xl text-charcoal pr-4 group-hover:text-gold transition-colors duration-500">
                    {q}
                </span>
                <span className="flex-shrink-0 mt-2 text-gold">
                    {open ? <Minus strokeWidth={1.25} size={22} /> : <Plus strokeWidth={1.25} size={22} />}
                </span>
            </button>
            <div
                className={`grid transition-all duration-700 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100 pb-8" : "grid-rows-[0fr] opacity-0"
                }`}
            >
                <div className="overflow-hidden">
                    <p className="max-w-3xl text-charcoal-soft text-lg leading-[1.85] pr-12">{a}</p>
                </div>
            </div>
        </div>
    );
}

export default function FAQ() {
    return (
        <section id="faq" data-testid="faq-section" className="py-28 lg:py-40" style={{ background: "#FAFAF8" }}>
            <div className="mx-auto max-w-[1100px] px-6 lg:px-12">
                <div className="text-center mb-16" data-reveal>
                    <span className="editorial-eyebrow">Considerations</span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal">
                        Frequently Asked
                    </h2>
                    <div className="editorial-divider mt-10"><span>✦</span></div>
                </div>

                <div data-reveal>
                    {faqs.map((f, i) => (
                        <Item key={i} idx={i} q={f.q} a={f.a} />
                    ))}
                </div>
            </div>
        </section>
    );
}
